module.exports = __webpack_public_path__ + "img/quanqiu.e6d80138.png";